import React from 'react'

export default function GalleryVideo(props) {
    return (
        <iframe width="350" height="200" src={props.videoSrc} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
    )
}
